import React from "react";

export default function walletIcon({ fill }) {
  return (
    <svg
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M0 6.2013C0 3.27798 0 1.81632 0.908159 0.908159C1.81632 0 3.27798 0 6.2013 0H13.7987C16.722 0 18.1837 0 19.0918 0.908159C19.736 1.5523 19.9232 2.47489 19.9777 4H14C11.7909 4 10 5.79086 10 8C10 10.2091 11.7909 12 14 12H19.9777C19.9232 13.5251 19.736 14.4477 19.0918 15.0918C18.1837 16 16.722 16 13.7987 16H6.2013C3.27798 16 1.81632 16 0.908159 15.0918C0 14.1837 0 12.722 0 9.7987V6.2013ZM14 5H19.9971C20 5.37056 20 5.77002 20 6.2013V9.7987C20 10.23 20 10.6294 19.9971 11H14C12.3431 11 11 9.65685 11 8C11 6.34315 12.3431 5 14 5ZM13 9C13.5523 9 14 8.55229 14 8C14 7.44772 13.5523 7 13 7C12.4477 7 12 7.44772 12 8C12 8.55229 12.4477 9 13 9Z"
        fill={fill}
      />
    </svg>
  );
}
